import React from 'react';
import ReactDOM from 'react-dom/client';

import { RecoilRoot } from 'recoil';
import toast from 'react-hot-toast';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (error: any) => {
        if (!error?.message) {
          toast.error('에러가 발생했습니다. 잠시후 다시 시도해주세요.');
        }
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <RecoilRoot>
          <CookiesProvider>
            <BrowserRouter basename="/workspace">
              <App />
            </BrowserRouter>
          </CookiesProvider>
        </RecoilRoot>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);
